/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MiniGameAddonSelection
 */
export interface MiniGameAddonSelection {
    /**
     * 
     * @type {Array<number>}
     * @memberof MiniGameAddonSelection
     */
    numberSelections: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof MiniGameAddonSelection
     */
    name: string;
}

/**
 * Check if a given object implements the MiniGameAddonSelection interface.
 */
export function instanceOfMiniGameAddonSelection(value: object): value is MiniGameAddonSelection {
    if (!('numberSelections' in value) || value['numberSelections'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function MiniGameAddonSelectionFromJSON(json: any): MiniGameAddonSelection {
    return MiniGameAddonSelectionFromJSONTyped(json, false);
}

export function MiniGameAddonSelectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): MiniGameAddonSelection {
    if (json == null) {
        return json;
    }
    return {
        
        'numberSelections': json['numberSelections'],
        'name': json['name'],
    };
}

export function MiniGameAddonSelectionToJSON(value?: MiniGameAddonSelection | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'numberSelections': value['numberSelections'],
        'name': value['name'],
    };
}

